import _ from 'underscore';
import { SETTING_OPTIONS } from '@bingads-webui-campaign/recommendation-core';
import { GENERATED_FROM_FILTER_STRING_TYPES } from './const';

export function removeFilter(gridView) {
  const curQuery = gridView.get('query');
  gridView.set({ query: _.omit(curQuery, 'filterOpportunity', 'filterRecommendation') });
}

export function filterByOpportunityId(gridView, ids = []) {
  // filter in recommendation level: Opportunities/any(i:(i/OpportunityId eq '171025051000011648'))
  // filter in opportunity level: OpportunityId eq '171025051000011648'
  const filterRecommendation = `Opportunities/any(i:(${_.map(ids, i => `i/OpportunityId eq '${i}'`).join(' or ')}))`;
  const filterOpportunity = `${_.map(ids, i => `OpportunityId eq '${i}'`).join(' or ')}`;
  const curQuery = gridView.get('query');

  gridView.set({
    query: _.defaults({
      filterOpportunity,
      filterRecommendation,
    }, curQuery),
  });
}

// TODO: MT has bug on filter. Will change it to another solution after MT is ready.
export function filterByAIAssetRecommendationCount(gridView, type) {
  const filterUserAssetRecommendation = 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.ResponsiveSearchAdsOpportunitySummary/HasAIAssetRecommendationCount eq 0';
  const filterAIAssetRecommendation = 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.ResponsiveSearchAdsOpportunitySummary/HasAIAssetRecommendationCount gt 0';
  const filterAllAssetRecommendation = 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.ResponsiveSearchAdsOpportunitySummary/HasAIAssetRecommendationCount ge 0';
  let filterRecommendation;
  if (type === GENERATED_FROM_FILTER_STRING_TYPES.AIGeneratedAssets) {
    filterRecommendation = filterAIAssetRecommendation;
  } else if (type === GENERATED_FROM_FILTER_STRING_TYPES.UserAssets) {
    filterRecommendation = filterUserAssetRecommendation;
  } else if (type === GENERATED_FROM_FILTER_STRING_TYPES.AllAssets) {
    filterRecommendation = filterAllAssetRecommendation;
  }

  const curQuery = gridView.get('query');

  gridView.set({
    query: _.defaults({
      filterRecommendation,
    }, curQuery),
  });
}

export function filterBySettingOptions(
  gridView,
  {
    recommendationType,
    addedOptions,
    isRemove = false,
  }
) {
  const curQuery = gridView.get('query');
  let settingOptions;
  if (isRemove) {
    settingOptions = _.filter(
      curQuery.settingOptions,
      item => item.AddedOptions !== addedOptions
    );
  } else {
    settingOptions = _.union(curQuery.settingOptions, [{
      OpportunityType: recommendationType,
      AddedOptions: addedOptions,
      RemovedOptions: SETTING_OPTIONS.NONE,
    }]);
  }
  gridView.set({
    query: _.defaults({
      settingOptions,
    }, curQuery),
  });
}
